import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermFaqCategory from '@/components/TermFaqCategory';

const FaqTroubleshootingRestrictionsPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">よくあるご質問</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <TermFaqCategory />
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">トラブル・利用制限</div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">迷惑行為について。</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">DONDONでは、すべてのお客様に安心・安全にご利用いただける環境を提供するため、各種サービスのご利用に際し、ガイドラインを設けております。<br/>また、他のお客様のご利用を妨げる行為や、ガイドラインに反する行為は「迷惑行為」として厳しく禁止しています。</div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">以下のページをよくご確認のうえ、ルールに沿ってご利用くださいますようお願いいたします。</div>
                  <Link to={`/terms/spam_behavior${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">迷惑行為について</Link>
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">利用制限について。</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">DONDONでは、すべてのお客様に安心してご利用いただくため、迷惑行為を固く禁止しております。<br/>該当する行為が確認された場合には、ご利用に制限を設けさせていただくことがあります。</div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">詳しくは、以下のページをご確認ください。</div>
                  <Link to={`/terms/restrictions${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">利用制限について</Link>
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">キャンセル料について。</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">以下のいずれかに該当し、取引がキャンセルとなった場合、キャンセル料（商品代金の10%）を出品者にご請求いたします。</div>
                
                <div className="flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-bold leading-7">キャンセル料が発生する主なケース</div>
                  <div className="justify-center text-black text-base font-normal leading-7">・発送期限を超過しても商品が発送されなかった場合<br/>・当社到着期限を超過しても商品が当社に到着せず、取引がキャンセルとなった場合<br/>・取引成立後、商品にガイドラインに反する状態不備が発覚し、取引がキャンセルされた場合<br/>※運送会社の事情、自然災害、公共交通機関の影響など不可抗力による配送遅延が原因で取引がキャンセルとなった場合には、当社にて内容を確認・調査のうえ、キャンセル料の取り下げを行う場合がございます。該当する可能性がある場合は、必ずお問い合わせフォームよりご連絡ください。</div>
                </div>
                
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-bold leading-7">悪質な出品行為とみなすケース</div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">以下の行為を含む、価格操作の形跡や意図的な出品トラブルが認められる場合、キャンセル料の請求に加え、アカウント機能の制限等の措置を講じることがあります。</div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">発送期限までに発送できない商品の出品を繰り返す行為<br/>他のお客様に迷惑となる行為<br/>誤解を招く内容の出品を繰り返す行為</div>
                </div>
                
                <div className="flex flex-col justify-start items-start">
                  <div className="justify-center text-black text-base font-bold leading-7">キャンセル料に関する注意事項</div>
                  <div className="justify-center text-black text-base font-normal leading-7">お支払い期限：請求日を除き7日間<br/>期限までに振込が確認できない場合：出品中の商品を運営にて削除<br/>キャンセル料に関する請求書・領収書は発行いたしません</div>
                </div>
                
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-bold leading-7">キャンセル料の支払い方法</div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">キャンセル料は、お支払い期限までに必ずご対応いただきますようお願いいたします。<br/>キャンセル料に関する請求書・領収書は発行いたしません</div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">キャンセル料が請求されている場合、マイページ上に「利用制限中」と表示されます。<br/>該当の表示をタップすると、詳細画面へ遷移しますので、表示内容をご確認のうえ、お支払い方法を選択してください。</div>
                </div>
                
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-bold leading-7">支払い完了まで制限される機能</div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">・出品機能<br/>・売上金の振込申請</div>
                </div>
              </div>
            </div>
          </div>
          
          <TermFaqCategory />
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default FaqTroubleshootingRestrictionsPage;